import React, {useEffect} from 'react'
import { useDispatch } from 'react-redux'
import { exchangeToken } from '../../../../slices/publish/facebook/thunk';
import { replace } from 'redux-first-history';
import { createSelector } from 'reselect';
import Cookies from 'js-cookie';
import Preloader from '../../../../Components/Common/Preloader';
import { toast } from 'react-toastify';
function FacebookAuthentication() {
  const dispatch = useDispatch();

  useEffect(() => {
    const lastLocation = Cookies.get('lastLocation');
    let publishObj = localStorage.getItem('publishObj');
    if (window.location.search && window.location.search.trim() !== '') {
      (async () => {
        const res = await dispatch(exchangeToken(window.location.search));
        if (res.status === 'ok') {
          try {
            publishObj = JSON.parse(publishObj);
          } catch (error) {
            publishObj = null;
          }
          dispatch(replace(lastLocation, publishObj));
          localStorage.clear('publishObj');
          toast.success(publishObj?.toastMessage, {autoClose: 3000});
        }
      })()
    } else {
      let path = lastLocation.split('/').filter(str => str.trim() !== '').slice(0, 3).join('/');
      dispatch(replace(`${window.location.href}/${path}/campaigns/filter/all`));
      toast.error('Something went wrong while authentication.');
    }
  }, []);

  return (
    <React.Fragment>
      <Preloader />
    </React.Fragment>
  )
}

export default FacebookAuthentication
